const useUserFirstName = ({ userName }: { userName: string | null }): string => {
  if (!userName) return userName;

  const firstWord = userName.split(' ')[0];

  if (firstWord.toLowerCase() === 'the') {
    return userName;
  } else {
    return firstWord;
  }
};

export default useUserFirstName;
